export const ADD_FORM_VALUE = 'ADD_FORM_VALUE';
export const LOADING_FORM_DATA = 'LOADING_FORM_DATA';
export const LOAD_FORM_DATA_SUCCESS = 'LOAD_FORM_DATA_SUCCESS';
export const LOAD_FORM_DATA_FAIL = 'LOAD_FORM_DATA_FAIL';
export const SUBMITTING_FORM = 'SUBMITTING_FORM';
export const SUBMIT_FORM_FAIL = 'SUBMIT_FORM_FAIL';
export const SUBMIT_FORM_SUCCESS =  'SUBMIT_FORM_SUCCESS';
export const CHANGE_TOGGLE = 'CHANGE_TOGGLE';